export default "__VITE_ASSET__JmIVdBxiferYbGHZxrt31Q__"